import TagManager from 'react-gtm-module'

import { env } from '@/env'

const tagManagerArgs = {
  gtmId: env.VITE_GOOGLE_TAG_MANAGER_KEY!,
}
TagManager.initialize(tagManagerArgs)
